import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Standard' },
    { value: 2, label: 'Sensitive' },
    { value: 3, label: 'Confidential' },
  ],
});
